module.exports = __webpack_public_path__ + "static/proxy-extension-picture-3x-1c4a5df9d6620ec35f63dd696355bf69.png";